module.exports = __webpack_public_path__ + "assets/img/worldviewImgActive-da009203.png";